import { withAutomations } from 'hocs';
import { AutomationFlow as AutomationFlowImpl } from '../components/automationFlow';
export const AutomationFlow = withAutomations(AutomationFlowImpl);
